import axiosInstance from "../../../core/api/interceptors/axiosInterceptor";

// GET: List all offers
export const getOffers = async () => {
  const res = await axiosInstance.get("offers/get-offers");
  return res.data;
};

// GET: Get offer by ID
export const getOffer = async (id) => {
  const res = await axiosInstance.get(`offers/get-offer/${id}`);
  return res.data;
};

// POST: Add new offer
export const addOffer = async (offer) => {
  const res = await axiosInstance.post("offers/add-offer", offer);
  return res.data;
};

// PUT: Update offer by ID
export const updateOffer = async (id, offer) => {
  const res = await axiosInstance.put(`offers/update-offer/${id}`, offer);
  return res.data;
};

// DELETE: Delete offer by ID
export const deleteOffer = async (id) => {
  const res = await axiosInstance.delete(`offers/delete-offer/${id}`);
  return res.data;
};

// POST: Convert offer by ID
export const convertOffer = async (id) => {
  const res = await axiosInstance.post(`offers/convert-offer/${id}`);
  return res.data;
};
// ✅ New: Convert offer to invoice
export const convertOfferToInvoice = async (offerId) => {
  try {
    const response = await api.post(`/offers/${offerId}/convert-to-invoice`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ New: Update offer status
export const updateOfferStatus = async (offerId, status) => {
  try {
    const response = await api.patch(`/offers/${offerId}/status`, { status });
    return response.data;
  } catch (error) {
    throw error;
  }
};